<template>
  <div id="app" class="h-100">
    <router-view
      v-if="!$store.state.app.waitingForConnection"
      :key="$route.fullPath"
    />
    <offline v-else />
  </div>
</template>

<script>
import { Offline } from 'common-views'
import { createUserManager } from '../../common/plugins/keycloakPlugin'
import { hideToastMixin } from '../../common/mixins/toaster/hideToast'

export default {
  name: 'App',
  components: {
    Offline,
  },
  mixins: [hideToastMixin],
  computed: {
    locale() {
      return this.$i18n.locale
    },
    online() {
      return this.$store.state.app.online
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/LOG_OUT', this.$kuzzle).then(() => {
        this.$router.push({ path: '/login', query: { logout: 'true' } })
        this.$keycloak.logoutRedirection()
      })
    },
  },
  watch: {
    locale(newValue) {
      if (newValue) {
        localStorage.setItem('locale', this.locale)
      }
    },
  },
  async mounted() {
    /**
     * APPLICATION BOOTSTRAP -- refactor this in a service if necessary.
     */
    this.$keycloak.userManager = createUserManager()
    if (this.$keycloak.userManager) {
      this.$keycloak.userManager.events.addSilentRenewError(
        async (errorResponse) => {
          if (errorResponse.error !== 'invalid_grant') {
            return
          }
          await this.$store.dispatch('auth/LOG_OUT', this.$kuzzle)
          this.$router.push({ path: '/login', query: { logout: 'true' } })
          this.$keycloak.logoutRedirection()
        },
      )
    }

    this.$kuzzle.addListener('connected', () => {
      this.$store.commit('app/SET_ONLINE')
    })
    this.$kuzzle.addListener('reconnected', () => {
      this.$store.commit('app/SET_ONLINE')
    })
    this.$kuzzle.addListener('disconnected', (event) => {
      if (event.origin !== 'websocket/auth-renewal') {
        this.$store.commit('app/SET_OFFLINE')
      }
    })
    this.$kuzzle.addListener('tokenExpired', async () => {
      this.$store.dispatch('auth/LOG_OUT', this.$kuzzle).then(() => {
        this.$router.push({ path: '/login', query: { logout: 'true' } })
        this.$keycloak.logoutRedirection()
      })
    })
    const persistedLocale = localStorage.getItem('locale')
    if (persistedLocale) {
      this.$i18n.locale = persistedLocale
    }
    await this.$kuzzle.connect()
  },
}
</script>

<style lang="scss">
// CoreUI Icons Set
@import '~@coreui/icons/css/all.min.css';
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~@fortawesome/fontawesome-free/css/all.min.css';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import '../../common/assets/styles/scss/style';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
